import React from 'react';
import { BaseComponent } from '../BaseComponent.js';
import $ from 'jquery';
import { Line } from 'react-chartjs-2';
import * as zoom from 'chartjs-plugin-zoom-mv';
import 'react-dates/initialize';
import { DateRangePicker } from 'react-dates';
import 'moment/locale/it';
import moment from 'moment'
import FontAwesome from 'react-fontawesome';
import { CSVLink, CSVDownload } from 'react-csv';

export class GraphBatteryModbus extends BaseComponent {
  constructor(props) {
    super(props);

    let startDate = moment().subtract(10,'d');
    let endDate = moment(moment().format('YYYY-MM-DD') + ' 23:59:59', "YYYY-MM-DD HH:mm:ss");

    this.state = {
      data: [],
      showGraph: false,
      startDate: startDate,
      endDate: endDate,
      focusedInput: null,
      limit: 1000,
      title: 'Temperatura',
      data_time_i: [],
      data_time_h: [],
      data_time_d: [],
      view: 'd',
      title: this.props.title,
      ieee: this.props.ieee,
    };

    this.filterDate = this.filterDate.bind(this);
    this.graphClick = this.graphClick.bind(this);
    this.changeView = this.changeView.bind(this);
    this.renderClassTab = this.renderClassTab.bind(this);
  }

  componentDidMount() {
    this.filterDate();
  }

  filterDate(offset) {
    if (isNaN(offset)) {
      offset = 0;
      this.setState({ data: [], data_time_i: [], data_time_h: [], data_time_d: [], });
    } else {
      offset = parseInt(offset, 10) + parseInt(this.state.limit, 10);
    }

    let data = {
      Action: 'GetStoredData',
      DeviceID: this.props.deviceID,
      Offset: offset,
      Queue: 100,
      Limit: this.state.limit,
    };
    if (this.state.startDate) {
      data.From = parseInt(this.state.startDate.format('X'), 10);
    }
    if (this.state.endDate) {
      let endDate = moment(this.state.endDate.format('YYYY-MM-DD') + ' 23:59:59', "YYYY-MM-DD HH:mm:ss");
      data.To = parseInt(endDate.format('X'), 10);
    }
    data = JSON.stringify(data);

    this.setState({ showGraph: false });

    $.ajax({
      method: 'POST',
      url: 'https://sparkjvm.com/cloud/json',
      headers: {
        'x-session': this.props.token,
      },
      dataType: 'json',
      data: data,
      xhrFields: {
        withCredentials: true
      },
      success: (res) => {
        let i = 0;
        let data = [];
        while (i < res.Data.length) {
          let j = 0;
          while (j < res.Data[i].length) {
            if (parseInt(res.Data[i][j].Id) === parseInt(this.state.ieee)) {
              res.Data[i][j].Timestamp = res.Timestamp[i];
              data.push(res.Data[i][j]);
            }
            j++;
          }
          i++;
        }

        // Cerco se ci sono altri dati oltre ai 1000 di limite
        if (res.Limit === res.Count) {
          this.setState({ data: this.state.data.concat(data) }, () => {
            this.filterDate(res.Offset);
          });
        } else {
          this.setState({ data: this.state.data.concat(data) }, () => {
            console.log(this.state.data);
            this.formatData();
          });
        }
      },
      error: (httpReq, status, exception) => {
        console.log(httpReq);
        console.log(status);
        console.log(exception);
      },
    });
  }

  formatData() {
    let data = this.state.data;
    let data_time_i = this.state.data_time_i;
    let data_time_h = this.state.data_time_h;
    let data_time_d = this.state.data_time_d;

    let i = 0;
    while (i < this.state.data.length) {
      if (this.state.data[i]) {
        let value = this.state.data[i][this.state.title];
        let timestamp = this.state.data[i].Timestamp;
        let timestampRounded = moment.unix(timestamp)
        let timestampRoundedFormat;

        // SALVO 3 DATE_TIME GIÀ FORMATTATI
        // FORZO A MINUTI
        timestampRoundedFormat = timestampRounded.format('YYYY-MM-DD HH:mm');
        timestampRoundedFormat = moment(timestampRoundedFormat + ':00', 'YYYY-MM-DD HH:mm:ss');
        timestampRoundedFormat = timestampRoundedFormat.format('X');
        // FINE MODIFICA DATA - POI AGGIUNGO I DATI SOMMANDOLI

        // SMISTAMENTO DATI CON ARROTONDAMENTO
        if (!data_time_i[timestampRoundedFormat]) {
          data_time_i[timestampRoundedFormat] = [];
        }
        data_time_i[timestampRoundedFormat].push(value);


        // FORZO A ORE
        timestampRoundedFormat = timestampRounded.format('YYYY-MM-DD HH');
        timestampRoundedFormat = moment(timestampRoundedFormat + ':00:00', 'YYYY-MM-DD HH:mm:ss');
        timestampRoundedFormat = timestampRoundedFormat.format('X');
        // FINE MODIFICA DATA - POI AGGIUNGO I DATI SOMMANDOLI

        // SMISTAMENTO DATI CON ARROTONDAMENTO
        if (!data_time_h[timestampRoundedFormat]) {
          data_time_h[timestampRoundedFormat] = [];
        }
        data_time_h[timestampRoundedFormat].push(value);


        // FORZO A GIORNI
        timestampRoundedFormat = timestampRounded.format('YYYY-MM-DD');
        timestampRoundedFormat = moment(timestampRoundedFormat + ' 00:00:00', 'YYYY-MM-DD HH:mm:ss');
        timestampRoundedFormat = timestampRoundedFormat.format('X');
        // FINE MODIFICA DATA - POI AGGIUNGO I DATI SOMMANDOLI

        // SMISTAMENTO DATI CON ARROTONDAMENTO
        if (!data_time_d[timestampRoundedFormat]) {
          data_time_d[timestampRoundedFormat] = [];
        }
        data_time_d[timestampRoundedFormat].push(value);
      }
      i++;
    }

    this.setState({ data_time_i: data_time_i, data_time_h: data_time_h, data_time_d: data_time_d }, () => {
      this.setState({ showGraph: true });
    });
  }

  changeView(view) {
    if (view) {
      this.setState({ view: view });
    }
  }

  graphClick() {
  }

  renderClassTab(view) {
    if (this.state.view === view) {
      return "tab__el tab__el--active";
    }
    return "tab__el";
  }

  renderGraph() {
    if (this.state.showGraph) {
      let i = 0;
      let labels = [];
      let data = [];
      let csvData = [
        ['Data', this.state.title],
      ];
      let dataView;
      switch (this.state.view) {
        case 'i':
          dataView = this.state.data_time_i;
          break;
        case 'h':
          dataView = this.state.data_time_h;
          break;
        default:
          dataView = this.state.data_time_d;
          break;
      }
      for (var k in dataView) {
        let j = 0;
        let timestampObject = dataView[k];
        let val = 0;
        while (j < timestampObject.length) {
          val += timestampObject[j];
          j++;
        }
        val = (val / j).toFixed(2);
        let date = this.timestampToDate(k);
        labels.push(date);
        data.push(val);
        csvData.push([date, val]);
      }

      let min = Math.min.apply(Math, data.map((o) => { if(!isNaN(parseInt(o))) { return parseInt(o) } else { return 0 } }));
      min = min - 2;
      let max = Math.max.apply(Math, data.map((o) => { if(!isNaN(parseInt(o))) { return parseInt(o) } else { return 0 } }));
      max = max + 2;

      let dataGraph = {
        labels: labels,
        datasets: [
          {
            label: this.state.title,
            data: data,
            fill: false,
            lineTension: 0.1,
            backgroundColor: '#1faae1',
            borderColor: '#1faae1',
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointBorderColor: '#1faae1',
            pointHoverBorderColor: '#1faae1',
            pointBackgroundColor: '#1faae1',
            pointHoverBackgroundColor: '#1faae1',
            pointBorderWidth: 5,
            pointHoverBorderWidth: 5,
            pointRadius: 1,
            pointHoverRadius: 5,
            pointHitRadius: 10,
          },
        ],
      };
      let options = {
        scales: {
          yAxes: [
            {
              ticks: {
                /*
                suggestedMin: min,
                suggestedMax: max
                */
              }
            }
          ]
        },
        onClick: this.graphClick,
        pan: {
          enabled: true,
          mode: 'x'
        },
        zoom: {
          enabled: true,
          mode: 'x',
        },

      };

      return(
        <div className="graphs__content">
          <div className="graphs__content__search">
            <div className="graphs__content__search__inside">
              <DateRangePicker
                startDatePlaceholderText="Da"
                endDatePlaceholderText="A"
                startDate={this.state.startDate}
                startDateId="date_from"
                endDate={this.state.endDate}
                endDateId="date_to"
                onDatesChange={({ startDate, endDate }) => this.setState({ startDate, endDate })}
                focusedInput={this.state.focusedInput}
                onFocusChange={focusedInput => this.setState({ focusedInput })}
                hideKeyboardShortcutsPanel={true}
                isOutsideRange={() => false}
                minimumNights={0}
              />
              <button className="button" onClick={ this.filterDate }>FILTRA</button>
              <ul className="tab">
                <li className={ this.renderClassTab('i') } onClick={ () => { this.changeView('i') } }>Minuti</li>
                <li className={ this.renderClassTab('h') } onClick={ () => { this.changeView('h') } }>Ore</li>
                <li className={ this.renderClassTab('d') } onClick={ () => { this.changeView('d') } }>Giorni</li>
              </ul>
            </div>
          </div>
          <Line data={ dataGraph } options={ options } height={100} />

          <CSVLink
            data={csvData}
            separator={";"}
            filename={this.state.title + ".csv"}
            className="button button--mtop"
            target="_blank"
          >
            SCARICA I DATI
          </CSVLink>
        </div>
      )
    }

    return(
      <div className="graphs__content">
        <div className="graphs__content__inside graphs__content__inside--search">
          Caricamento dati <FontAwesome name='spinner' spin />
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="graphs graphs--nomargin">
        <div className="graphs__topbar">{ this.state.title }</div>
        { this.renderGraph() }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/graphs/GraphBatteryModbus.js